<template>
  <div class="base-vimeo" />
</template>

<script>
import Player from '@vimeo/player'
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.player = new Player(this.$el, {
      id: this.id,
      responsive: true
    })
  }
}
</script>

<style lang="scss" scoped>
.base-vimeo {
  position: relative;
  width: 100%;
  height: auto;
  overflow: hidden;
  border: var(--border-1);
  border-radius: var(--br-1);
}
</style>
